import React from 'react';
import { Tag } from 'lucide-react';
import { productPriceView } from '../utils/offerPresentation';

// The offer the backend applied to this product's price, and any multi-buy
// offer it attached, exactly as the projection returned them. Renders nothing
// when the projection carries neither — no offer is ever looked up here.
const ProductOfferNote = ({ product, className = '' }) => {
  const { offer, basketOffer } = productPriceView(product);
  if (!offer && !basketOffer) return null;

  return (
    <span className={`flex flex-wrap items-center gap-1.5 ${className}`} data-testid="product-offer">
      {offer && (
        <span className="inline-flex items-center gap-1 max-w-full text-[11px] font-semibold text-accent-700 bg-accent-50 border border-accent-100 px-2 py-0.5 rounded-full">
          <Tag size={11} className="shrink-0" aria-hidden="true" />
          <span className="sr-only">Offer: </span>
          <span className="truncate">{offer.label}</span>
        </span>
      )}
      {basketOffer && (
        <span className="inline-flex items-center gap-1 max-w-full text-[11px] font-medium text-emerald-800 bg-emerald-50 border border-emerald-100 px-2 py-0.5 rounded-full">
          <span className="sr-only">Multi-buy offer: </span>
          <span className="truncate">{basketOffer.label}</span>
        </span>
      )}
    </span>
  );
};

export default ProductOfferNote;
